import React, {Component} from 'react';
import Register from '../../auth/signup'
import {connect} from "react-redux";
import {Field, reduxForm} from 'redux-form'
import { addClient } from '../../../actions/index'
import {Container, Row, Col, Card, CardBlock, CardFooter, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import {renderCal, renderInput, renderCheckbox} from '../../forms/newcaso/Fields'

class NewClient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: null
        };
    }

    handleFormSubmit(values) {
        console.log(values);
        values.lab_id = this.props.lab
        this.props.addClient(values);
    }

    renderSelect(field) {
        let options = [
            <option key="_0" value="_0">Seleccione provincia</option>,
            <option key="1" value="1">Lab 1</option>,
            <option key="2" value="2">Lab 2</option>
        ]
        return (
            <div className="form-group">
                <select
                    className="form-control"
                    {...field.input}
                >
                    {options}
                </select>
                {field.meta.touched && field.meta.error && <span className="text-danger">{field.meta.error}</span>}
            </div>
        )
    }

    renderError(msg) {
        return (
            <div className="alert alert-danger" role="alert">
                {msg || "Ha ocurrido un error de conexión por favor intentelo de nuevo más tarde."}
            </div>
        )
    }

    renderContainer() {
        const {handleSubmit} = this.props;
        return (
            <div className="justify-content-md-center">
                <div className="col-12 content-container form-container">
                    {this.renderForm()}
                </div>
            </div>
        )
    }

    renderForm() {
        const {handleSubmit} = this.props;
        return (
            <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
                <h1>Nuevo Cliente</h1>
                <p className="text-muted">Registro de nuevo cliente</p>
                {this.state.status === "error" && this.renderError()}
                <div className="form-row">
                    <Field
                        name="num_colegiado"
                        col="col-md-6"
                        label="Número de colegiado"
                        component={renderInput}
                    />
                    <Field
                        name="phone"
                        col="col-md-6"
                        label="Teléfono"
                        component={renderInput}
                    />
                    <Field
                        name="nombre"
                        col="col-md-6"
                        label="Nombre"
                        component={renderInput}
                    />
                    <Field
                        name="apellidos"
                        col="col-md-6"
                        label="Apellidos"
                        component={renderInput}
                    />
                    <Field
                        name="email"
                        col="col-md-12"
                        label="Email"
                        component={renderInput}
                    />
                </div>
                <div className="form-actions text-right">
                    <button type="button" onClick={this.props.previousPage} className="btn btn-link text-secondary">
                        Cancelar
                    </button>
                    <button type="submit" className="btn btn-primary next">Enviar &nbsp;<i
                        className="fa fa-check-circle-o"></i></button>
                </div>
            </form>
        )
    }

    renderLoading() {
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <div className="text-center"><i
                            className="text-muted fa-5x fa fa-spin fa-circle-o-notch"></i></div>
                    </Row>
                </Container>
            </div>
        )

    }

    renderSuccess() {
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <div className="text-center"><i className="text-success fa fa-5x fa-check-circle-o"></i>
                            <p className="lead">Su solicitud se ha enviado</p><span className="text-muted">En breve nos pondremos en contacto, gracias.</span>
                        </div>
                    </Row>
                </Container>
            </div>
        )
    }

    render() {
        return (
            <div>
                {{
                    null: (
                        this.renderContainer()
                    ),
                    'error': (
                        this.renderContainer()
                    ),
                    'loading': (
                        this.renderLoading()
                    ),
                    'success': (
                        this.renderSuccess()
                    )
                }[this.state.status]}
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        lab: state.user.lab_id
    };
}
const validate = (values) => {
    const msg_req = "Campo requerido";
    let errors = {};
    if (!values.nombre) {
        errors.nombre = msg_req;
    }
    if (!values.apellidos) {
        errors.apellidos = msg_req;
    }
    if (!values.phone || !/^[679]{1}[0-9]{8}$/i.test(values.phone)) {
        errors.phone = msg_req;
    }
    if (!values.num_colegiado || !/^\d+$/i.test(values.num_colegiado)) {
        errors.num_colegiado = msg_req;
    }
    if (!values.email || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = msg_req;
    }
    return errors;
}
NewClient = reduxForm({
    form: 'signup',
    validate: validate
})(NewClient);
export default NewClient = connect(mapStateToProps, {addClient})(NewClient);


// WEBPACK FOOTER //
// ./resources/assets/js/components/admin/clients/newClient.jsx